import { MdApi, MdAutoAwesome, MdDynamicForm } from 'react-icons/md';
import { SiGooglesheets } from 'react-icons/si';

// One logo and one color per kind of integration, shared by the choice of type (start.tsx) and
// "Mes intégrations" (list.tsx) so a kind looks the same everywhere.
export type IntegrationKind = 'site' | 'ai' | 'api' | 'sheet';

const KINDS: Record<IntegrationKind, { Icon: React.ComponentType<{ className?: string }>; tile: string }> = {
    site: { Icon: MdDynamicForm, tile: 'bg-[#EAE6FF] text-[#4B3BD6]' },
    ai: { Icon: MdAutoAwesome, tile: 'bg-[#FFF0E6] text-[#E8590C]' },
    api: { Icon: MdApi, tile: 'bg-[#E6F3FF] text-[#1D6FD8]' },
    sheet: { Icon: SiGooglesheets, tile: 'bg-[#E6F4EA] text-[#0F9D58]' },
};

export const KindLogo = ({ kind, size = 'md' }: { kind: IntegrationKind; size?: 'sm' | 'md' }) => {
    const { Icon, tile } = KINDS[kind];
    return (
        <span
            className={`flex shrink-0 items-center justify-center ${tile} ${
                size === 'sm' ? 'h-9 w-9 rounded-[10px]' : 'h-11 w-11 rounded-[12px]'
            }`}
        >
            <Icon className={size === 'sm' ? 'h-5 w-5' : 'h-6 w-6'} />
        </span>
    );
};
